import { REACT_APP_API_BASE_URL } from "../../constants/config";

export async function getAgoraToken(channelName: string, uid: string): Promise<string> {
  if (!channelName || !uid) {
    throw new Error("Channel name and UID are required to generate Agora token");
  }

  const url = `${REACT_APP_API_BASE_URL}/agora/${channelName}/${uid}`;
  console.log("[getAgoraToken] Request URL:", url);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("[getAgoraToken] Response Status:", response.status, response.statusText);

    if (!response.ok) {
      throw new Error(`Failed to fetch token (Status: ${response.status})`);
    }

    const result = await response.json();
    console.log("[getAgoraToken] API Response:", result);

    const token = result?.data?.token;
    if (!token) {
      throw new Error("Token not found in API response");
    }

    console.log("[getAgoraToken] Token retrieved successfully");
    return token;
  } catch (err: any) {
    console.error("[getAgoraToken] ERROR:", err);
    throw new Error(`Error in token generation: ${err.message || err}`);
  }
}

/**
 * Fetch Agora RTM token for messaging login.
 * Required when the Agora project has "dynamic key" (token auth) enabled.
 * Returns null if the backend does not expose GET /agora/rtm/:uid (e.g. 404).
 */
export async function getAgoraRtmToken(uid: string): Promise<string | null> {
  if (!uid) return null;
  const url = `${REACT_APP_API_BASE_URL}/agora/rtm/${encodeURIComponent(uid)}`;
  try {
    const response = await fetch(url, { method: "GET", headers: { "Content-Type": "application/json" } });
    if (!response.ok) return null;
    const result = await response.json();
    const token = result?.data?.token;
    return typeof token === "string" && token ? token : null;
  } catch {
    return null;
  }
}
